export const customClasses = {
  questionText: "text-left font-bold mt-10 mb-4 capitalize text-lg",
  helperText: "text-md text-gray-700 mt-5",
  helperTextBold: "text-md text-gray-700 mt-5 font-bold",
  stepsWrapper: " mx-auto w-5/6 md:w-2/3 lg:w-1/2 xl:w-1/3 pt-16",
};
